import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Typography, Divider, Link, useTheme, useMediaQuery } from '@material-ui/core'
import { Security, Info, Warning } from '@material-ui/icons'

import { Page } from 'components'
import { Formulario } from './components'
import useStyles from './EsqueceuSenha.styles'

export const EsqueceuSenha = () => {
  const theme = useTheme()
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'))
  const classes = useStyles()

  return (
    <Page className={classes.root} title="Esqueceu a senha? - SIGEP">
      {/* 1. Painel Visual Decorativo (Esquerda - Oculto no Mobile) */}
      <div className={classes.visualPane}>
        <div className={classes.visualContent}>
          <Typography className={classes.visualSubtitle} variant="button">
            POLÍCIA CIENTÍFICA / RN
          </Typography>
          <Typography className={classes.visualTitle} variant="h1">
            Sistema Integrado de Gestão de Perícias
          </Typography>
          <Typography className={classes.visualDesc} variant="body1">
            Este é um sistema oficial da Polícia Científica do Rio Grande do Norte voltado para o gerenciamento e controle de perícias.
          </Typography>

          <div className={classes.securityCard}>
            <div className={classes.securityItem}>
              <div className={classes.securityIcon}>
                <Security fontSize="small" />
              </div>
              <span className={classes.securityText}>
                Acesso exclusivo para servidores da segurança pública e de outros órgãos oficiais credenciados.
              </span>
            </div>
            <div className={classes.securityItem}>
              <div className={classes.securityIcon}>
                <Info fontSize="small" />
              </div>
              <span className={classes.securityText}>
                Todas as consultas e alterações de dados são registradas, auditadas e vinculadas ao seu CPF.
              </span>
            </div>
            <div className={classes.securityItem}>
              <div className={classes.securityIcon}>
                <Warning fontSize="small" />
              </div>
              <span className={classes.securityText}>
                O uso indevido deste sistema e de suas informações sujeita o infrator a sanções administrativas, civis e penais.
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* 2. Painel de Login e Acesso (Direita) */}
      <div className={classes.formPane}>
        <div className={classes.formContainer}>
          {/* Logo da Plataforma */}
          <div className={classes.logoWrapper}>
            <img alt="Logo SIGEP" src="/images/logo-sigep.png" className={classes.logo} />
          </div>

          {/* Cabeçalho */}
          <div className={classes.headerWrapper}>
            <Typography className={classes.formTitle} variant="h2">
              Esqueci minha senha
            </Typography>
            <Typography className={classes.formSubtitle} variant="body2">
              Para redefinir a sua senha informe o seu CPF e lhe enviaremos por e-mail um link com as instruções.
            </Typography>
          </div>

          {/* Formulário de Recuperação */}
          <Formulario className={classes.loginForm} />

          <Divider className={classes.divider} />

          {/* Link para voltar ao Login */}
          <Link align="center" component={RouterLink} to="/auth/login" underline="always" variant="subtitle2" className={classes.backToLoginLink}>
            Voltar a tela de login
          </Link>

          {/* Rodapé Institucional */}
          <div className={classes.footerWrapper}>
            <img alt="Logo do ITEPRN e do GOVRN" src="/images/logos/logo-itep-govrn-footer.png" className={classes.footerLogo} />
          </div>
        </div>
      </div>
    </Page>
  )
}
